import React from "react";
import { EDUCATION, CAREER, PROFILE } from "../../mock";
import { GraduationCap, Briefcase } from "lucide-react";
import { SectionTitle } from "./About";

export default function Timeline() {
  return (
    <section id="journey" className="scroll-smooth-section py-24">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <SectionTitle
          kicker="Journey"
          title="Five decades of learning and service"
          subtitle="From a Botany degree in 1970 to FRCP London in 2011 — a continuous arc of education, teaching and bedside neurology."
        />

        <div className="mt-14 grid lg:grid-cols-2 gap-12">
          {/* Education */}
          <div>
            <div className="flex items-center gap-3 mb-8">
              <div className="w-12 h-12 rounded-full bg-emerald-soft flex items-center justify-center">
                <GraduationCap className="w-6 h-6 text-emerald-deep" />
              </div>
              <div>
                <div className="text-xs uppercase tracking-widest text-gold">Education</div>
                <div className="font-display text-2xl text-emerald-deep">Academic milestones</div>
              </div>
            </div>
            <ol className="relative border-l-2 border-gold/40 ml-5 space-y-7">
              {EDUCATION.map((e, i) => (
                <li key={i} className="pl-8 relative">
                  <span className="absolute -left-[11px] top-1 w-5 h-5 rounded-full bg-emerald-deep border-4 border-ivory pulse-dot" />
                  <div className="bg-ivory rounded-xl p-5 shadow-sm border border-stone-200/60 lift">
                    <div className="flex items-center gap-3 flex-wrap">
                      <span className="year-chip">{e.year}</span>
                      <span className="text-stone-500 text-[10px] uppercase tracking-[0.25em]">Degree</span>
                    </div>
                    <div className="font-display text-lg text-emerald-deep mt-3">{e.degree}</div>
                    <div className="text-stone-600 text-sm mt-0.5">{e.institution}</div>
                  </div>
                </li>
              ))}
            </ol>
          </div>

          {/* Career */}
          <div>
            <div className="flex items-center gap-3 mb-8">
              <div className="w-12 h-12 rounded-full bg-gold/20 flex items-center justify-center">
                <Briefcase className="w-6 h-6 text-gold" />
              </div>
              <div>
                <div className="text-xs uppercase tracking-widest text-gold">Career</div>
                <div className="font-display text-2xl text-emerald-deep">Three decades of service</div>
              </div>
            </div>
            <ol className="relative border-l-2 border-emerald-deep/30 ml-5 space-y-7">
              {CAREER.map((c, i) => (
                <li key={i} className="pl-8 relative">
                  <span className="absolute -left-[11px] top-1 w-5 h-5 rounded-full bg-gold border-4 border-ivory" />
                  <div className="bg-emerald-soft rounded-xl p-5 lift border border-emerald-deep/10">
                    <div className="inline-flex items-center gap-2 bg-emerald-deep/10 text-emerald-deep px-3 py-1 rounded-full text-[11px] uppercase tracking-[0.2em] font-medium">{c.period}</div>
                    <div className="font-display text-lg text-stone-800 mt-3">{c.role}</div>
                    <div className="text-stone-600 text-sm mt-0.5">{c.place}</div>
                  </div>
                </li>
              ))}
            </ol>

            <div className="mt-8 premium-frame">
              <div className="inner">
                <img src={PROFILE.images.consult} alt="At consulting room" className="w-full h-72 object-cover" style={{ objectPosition: "center 30%" }} />
                <div className="p-5 bg-ivory">
                  <div className="text-[10px] uppercase tracking-[0.3em] text-gold">Today</div>
                  <div className="font-display text-emerald-deep text-lg mt-1">{PROFILE.current}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
